import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import "./index.css";

const DropdownAndAutocomplete = ({ data, onResultClick }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [filteredData, setFilteredData] = useState(data);
  const { t } = useTranslation();

  const options = [
    t("INVOICE_DATE"),
    t("INVOICE_NO"),
    t("PRODUCT_SERVICE"),
    t("NICKNAME"),
  ];

  const handleOptionChange = (event, value) => {
    setSelectedOption(value);

    if (value === "") {
      setFilteredData(data);
    } else {
      const filteredItems = data.filter((item) => {
        switch (value) {
          case `${t("INVOICE_DATE")}`:
            return item.invoice_date !== null;
          case `${t("INVOICE_NO")}`:
            return item.invoice_number !== null;
          case `${t("PRODUCT_SERVICE")}`:
            return (
              (item.type_material &&
                Object.keys(item.type_material).length !== 0) ||
              (item.type_service &&
                Object.keys(item.type_service).length !== 0) ||
              (item.type_machinery &&
                Object.keys(item.type_machinery).length !== 0) ||
              (item.type_buildingmaterial &&
                Object.keys(item.type_buildingmaterial).length !== 0) ||
              (item.type_packaging &&
                Object.keys(item.type_packaging).length !== 0) ||
              (item.type_vehicle &&
                Object.keys(item.type_vehicle).length !== 0) ||
              (item.type_chemical &&
                Object.keys(item.type_chemical).length !== 0)
            );
          case `${t("NICKNAME")}`:
            return item.nickname !== null;
          default:
            return item.nickname !== null;
        }
      });
      setFilteredData(filteredItems);
    }
  };

  return (
    <div className="sort-quick-navigate">
      <p
        style={{
          marginBottom: "0",
          padding: "12px",
          marginRight: "20px",
          color: "#FBFBFB",
          fontSize: "14px",
        }}
      >
        {t("SEARCH_AFTER")}
      </p>
      <div>
        <Autocomplete
          placeholder="Choose"
          options={options}
          value={selectedOption}
          onChange={handleOptionChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("CHOOSE")}
              InputLabelProps={{ style: { color: "white", fontSize: "12px" } }}
              InputProps={{
                ...params.InputProps,
                className: "sort-input",
              }}
            />
          )}
          classes={{
            option: {
              "&.Mui-selected": {
                color: "white",
              },
            },
            paper: "sort-custom-dropdown",
          }}
          sx={{
            width: "180px",
          }}
        />
      </div>
      <div style={{ marginLeft: "20px" }}>
        <Autocomplete
          options={filteredData}
          getOptionLabel={(option) => {
            switch (selectedOption) {
              case `${t("INVOICE_DATE")}`:
                return option.invoice_date;
              case `${t("INVOICE_NO")}`:
                return option.invoice_number;
              case `${t("PRODUCT_SERVICE")}`:
                if (option.type_material && option.type_material.name) {
                  return option.type_material.name;
                } else if (option.type_service && option.type_service.name) {
                  return option.type_service.name;
                } else if (
                  option.type_machinery &&
                  option.type_machinery.name
                ) {
                  return option.type_machinery.name;
                } else if (
                  option.type_buildingmaterial &&
                  option.type_buildingmaterial.name
                ) {
                  return option.type_buildingmaterial.name;
                } else if (
                  option.type_packaging &&
                  option.type_packaging.name
                ) {
                  return option.type_packaging.name;
                } else if (option.type_vehicle && option.type_vehicle.name) {
                  return option.type_vehicle.name;
                } else if (option.type_chemical && option.type_chemical.name) {
                  return option.type_chemical.name;
                } else {
                  return "";
                }
              case `${t("NICKNAME")}`:
                return option.nickname;
              default:
                return option.nickname;
            }
          }}
          sx={{
            width: "200px",
            "& .MuiAutocomplete-option.Mui-selected": {
              color: "white",
            },
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField
              placeholder={t("START_TYPING")}
              {...params}
              InputProps={{
                ...params.InputProps,
                style: { color: "white" },
                className: "sort-input",
              }}
            />
          )}
          classes={{
            option: {
              "&.Mui-selected": {
                color: "white",
              },
            },
            paper: "sort-custom-dropdown",
          }}
          onChange={(event, option) => {
            if (!selectedOption) {
              return;
            }

            let identifier = option && option?.id;

            onResultClick(identifier);
          }}
          onClick={(option) => onResultClick(option.id)}
        />
      </div>
    </div>
  );
};

export default DropdownAndAutocomplete;
